// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"26":"dba44bdee970fe6027c0","925":"87aeb17befe1a99ff62c"}[chunkId] + ".css";
};